import styled from "styled-components"
import SearchResult from "./search-result"

export default styled(SearchResult)``
